'use client';

import { useEffect } from 'react';
import { useCartStore } from 'stores/cart';

/**
 * ResetCartStore - Clears client cart state when the server renders an empty cart
 *
 * Live prices, deleted IDs and the badge count outlive the last delete otherwise.
 *
 * Renders nothing — state sync only.
 */
export function ResetCartStore() {
  const resetCart = useCartStore(s => s.resetCart);

  useEffect(() => {
    resetCart();
  }, [resetCart]);

  return null;
}
